import { BaseError } from 'src/app/core/contracts/errors/base.error';
import { CoreErrorCodes } from 'src/app/core/contracts/errors/error-codes';
export class InternalError extends BaseError {
  public args: unknown;
  public stacktrace: unknown;
  public override name: string;
  constructor(public override message: string, public code: string = CoreErrorCodes.Unknown, public handleError: boolean = true, ...args: unknown[]) {
    super(message);
    this.name = 'InternalError'; // this.constructor.name is useless after minification
    this.args = args;
  }
}
